import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";
import SoftButton from "components/SoftButton";
import { ApiResponse } from "model/apiResponseModel";
import api from "api/api";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import SearchField from "components/SearchField";
import { Avatar, Box } from "@mui/material";
import ConfirmDialog from "layouts/leaderboard/components/ConfirmDialog";
import StreakGlobalSettingsDialog from "./components/global-settings-dialog";
import AddIcon from "@mui/icons-material/Add"
import DeleteTableButton from "components/DeleteTableButton";

                                                                                                                                              

const formatGroupHeading = (group) => {
  if (group == null || group === "") return "Configurations";
  if (typeof group !== "string") return String(group);
  return group
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

/** Turn snake_case / slug strings into Title Case labels */
const humanize = (input) => {
  if (input == null || input === "") return "—";
  const s = String(input).trim();
  if (!s) return "—";
  return s
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
};
   
/** Readable label: slug-like strings get title case; normal phrases stay as-is */
const friendlyLabel = (input) => {
  if (input == null || input === "") return "—";
  const s = String(input).trim();
  if (!s) return "—";
  if (s.includes("_") || /^[a-z][a-z0-9_]*$/i.test(s)) return humanize(s);
  return s;
};

                                                                                      
                                                     

const formatConfigValue = (value) => {
  if (value === null || value === undefined || value === "") return "—";
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (typeof value === "number") return Number.isInteger(value) ? String(value) : String(value);
  if (typeof value === "object") {
    try {
      return JSON.stringify(value);
    } catch {
      return String(value);
    }
  }
 
   

  const str = String(value).trim();
  if (/^(true|false)$/i.test(str)) return str.toLowerCase() === "true" ? "Yes" : "No";
  if (/^-?\d+(\.\d+)?$/.test(str)) return str;
  return str;
};

                                                 

export default function Rules() {
  const location = useLocation();
  const [columns, setColumns] = useState([]);
  const [streakSettings, setStreakSettings] = useState();
  const [isOpenGlobalSettingsDialog, setIsOpenGlobalSettingsDialog] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [deleteConfigId, setDeleteConfigId] = useState("");
  const [isOpenDeleteDialog, setIsOpenDeleteDialog] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  /** Grouped config tables: { group, rows }[] when API returns groupByGroup */
  const [configGroups, setConfigGroups] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 10;
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  
    const handleSearch = () => {
        if (searchQuery != "") {
           setCurrentPage(1);
           fetchConfigs(1, searchQuery);
        }
    };

    const handleClearSearch = () => {
        if (searchQuery != "") {
            setCurrentPage(1);
            setSearchQuery("");
            fetchConfigs(1, "");
        }
    };

    const isAddOrEdit = location.pathname.startsWith("/rules/add") || location.pathname.startsWith("/rules/edit");
    const isEdit = location.pathname.startsWith("/rules/edit");

  const fetchConfigs = async (page = 1, search) => {
    try {
      setIsLoading(true);
      let postData = {
        limit,
        page,
        groupByGroup: true,
      };

      if (search && search.trim() !== "") {
        postData.search = search.trim();
      }

      const response = await api.getGamificationConfigs(postData);
      const apiResponse = new ApiResponse(response.status, response.message);

      if (apiResponse.status === 1) {
        const payload = response.data || {};
        const rawList = payload.configs;

        const mapConfigToRow = (item, includeGroupColumn) => ({
          linkPath: `/configs`,
          name: (
            <SoftBox display="flex" alignItems="center" px={1} pb={0.5}>
              <SoftBox display="flex" flexDirection="column" ml={2}>
                <SoftTypography variant="button" fontWeight="medium">
                  {humanize(item.key)}
                </SoftTypography>
                {/* {item.key != null &&
                  String(item.key).includes("_") && (
                    <SoftTypography variant="caption" color="secondary">
                      {String(item.key)}
                    </SoftTypography>
                  )} */}
              </SoftBox>
            </SoftBox>
          ),
          // label: (
          //   <SoftTypography
          //     variant="caption"
          //     fontWeight="medium"
          //     sx={{
          //       display: "flex",
          //       alignItems: "center",
          //       justifyContent: "center",
          //       minHeight: "40px",
          //       maxWidth: "220px",
          //     }}
          //   >
          //     {friendlyLabel(item.label)}
          //   </SoftTypography>
          // ),
          "points Reward": (
            <SoftTypography
              variant="caption"
              fontWeight="bold"
              color="dark"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "40px",
              }}
            >
              {formatConfigValue(item.value)}
            </SoftTypography>
          ),
          ...(includeGroupColumn
            ? {
                group: (
                  <SoftTypography
                    variant="caption"
                    fontWeight="medium"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      color: item?.color,
                    }}
                  >
                    {item?.icon && (
                      <Avatar
                        src={item.icon}
                        alt={item?.name}
                        sx={{ width: 18, height: 18 }}
                      />
                    )}
                    {item?.group}
                  </SoftTypography>
                ),
              }
            : {}),
          description: (
            <SoftTypography
              variant="caption"
              color="secondary"
              fontWeight="medium"
              sx={{
                display: "flex",
                alignItems: "center",
                height: "100%",
                minHeight: "40px",
                maxWidth: "280px",
              }}
            >
              {item.description != null && item.description !== ""
                ? item.description
                : "—"}
            </SoftTypography>
          ),
          actions: (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              width="100%"
            >
              <SoftTypography
                component={Link}
                to={`/rules/edit/?configId=${item?._id}`}
                variant="caption"
                color="secondary"
                fontWeight="medium"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  minHeight: "40px",
                }}
              >
                Edit
              </SoftTypography>
              <DeleteTableButton
                onClick={() => {
                  setDeleteConfigId(item?._id);
                  setIsOpenDeleteDialog(true);
                }}
              />
            </Box>
          ),
        });

        const list = Array.isArray(rawList) ? rawList : [];
        const isGrouped =
          list.length > 0 &&
          list[0] &&
          typeof list[0] === "object" &&
          Array.isArray(list[0].configs);

        if (isGrouped) {
          setColumns([
            { name: "name", align: "left" },
            // { name: "label", align: "center" },
            { name: "points Reward", align: "center" },
            { name: "description", align: "center" },
            { name: "actions", align: "center" },
          ]);
          setConfigGroups(
            list.map((g) => ({
              group: g.group,
              rows: (g.configs || []).map((item) =>
                mapConfigToRow(item, false)
              ),
            }))
          );
        } else {
          setColumns([
            { name: "name", align: "left" },
            // { name: "label", align: "center" },
            { name: "points Reward", align: "center" },
            { name: "group", align: "center" },
            { name: "description", align: "center" },
            { name: "actions", align: "center" },
          ]);
          setConfigGroups([
            {
              group: null,
              rows: list.map((item) => mapConfigToRow(item, true)),
            },
          ]);
        }

        setTotalPages(payload.totalPages ?? 1);
      }
    } catch (error) {
      console.error("Error fetching configs:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchStreakGlobalSettings = async() => {
    try {
      setIsLoading(true);

      const response = await api.getStreakGlobalSettings();
      console.log("Response is", response);
      if(response?.status === 1){
        setStreakSettings(response?.data);
      } else {
        console.error(response?.message || "Error fetching global settings");
      }
    } catch (error) {
        console.error("Error fetching streak global settings:", error);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    const loginData = JSON.parse(
      localStorage.getItem("loginData") || sessionStorage.getItem("loginData")
    );

    if (!loginData) {
      navigate("/authentication/sign-in");
    } else {
      fetchConfigs(currentPage, searchQuery);
      fetchStreakGlobalSettings();
    }
  }, [currentPage, navigate, searchQuery]);

  const handlePageClick = (page) => {
    setCurrentPage(page);
    // console.log(page);
    fetchConfigs(page, searchQuery);
  };

  const handleClose = () => {
    setIsOpenGlobalSettingsDialog(false);
  }

  const handleUpdateStreakGlobalSettings = async ({grace_days_allowed, grace_window_reset_days}) => {
    if(!streakSettings?._id)return;
    try {
        setIsUpdating(true);
        const response = await api.updateStreakGlobalSettings({settings_id: streakSettings?._id, grace_days_allowed, grace_window_reset_days});

        if(response.status){
            setIsOpenGlobalSettingsDialog(false);
            fetchStreakGlobalSettings();
        } else {
            alert(response?.message);
        }
    } catch (error) {
        alert(error?.message);
    } finally {
        setIsUpdating(false);
    }
  }

  const handleCloseDeleteDialog = () => {
    setIsOpenDeleteDialog(false);
  };

  const handleConfirmDelete = async () => {
    try {
      setIsDeleting(true);
      const response = await api.deleteGamificationConfig({ id: deleteConfigId });
      const apiResponse = new ApiResponse(response.status, response.message);

      if (apiResponse.status === 1) {
        setIsOpenDeleteDialog(false);
        window.location.href = "/rules";
      } else {
        alert(apiResponse.message);
      }
    } catch (error) {
      console.error("Error deleting config:", error);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {isAddOrEdit ? (<Outlet /> ) : (
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Card sx={{mb: 3}}>
            <SoftBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
              <SoftTypography variant="h6" width="20%">
                Streak Global Settings
              </SoftTypography>
              <SoftButton
                variant="gradient"
                color="info"
                onClick={()=>setIsOpenGlobalSettingsDialog(true)}
                >
                    Update Settings
                </SoftButton>
            </SoftBox> 
            <SoftBox 
                sx={{ 
                    display: "flex", 
                    flexDirection: "row", 
                    gap: 6, // Space between the two rows
                    px: 2,  // Internal horizontal padding
                    py: 1   // Internal vertical padding
                }}
            >
                <SoftBox display="flex" justifyContent="space-between" alignItems="center" flex="1">
                    <SoftTypography variant="button" fontWeight="medium" color="text">
                    Grace Days Allowed
                    </SoftTypography>
                    <SoftTypography variant="button" fontWeight="bold" color="dark">
                        {streakSettings?.grace_days_allowed}
                    </SoftTypography>
                </SoftBox>

                <SoftBox display="flex" justifyContent="space-between" alignItems="center" flex="1">
                    <SoftTypography variant="button" fontWeight="medium" color="text">
                    Grace Windows Reset
                    </SoftTypography>
                    <SoftTypography variant="button" fontWeight="bold" color="dark">
                    {streakSettings?.grace_window_reset_days}
                    </SoftTypography>
                </SoftBox>
            </SoftBox>
          </Card>
          <Card>
            <SoftBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
              <SoftTypography variant="h6" width="20%">
                Configurations
              </SoftTypography>
              <SoftBox display="flex" alignItems="center" gap={2}>
                <SearchField
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onSearch={handleSearch}
                onClear={handleClearSearch}
                />

    
                {/* ➕ Add Button */}
                <SoftButton
                variant="gradient"
                color="info"
                startIcon={<AddIcon />}
                onClick={() => navigate("/rules/add")}
                >
                    Add
                </SoftButton>
            </SoftBox>
              {/* <ProjectFilter status={status} setStatus={setStatus} /> */}
            </SoftBox>
            <SoftBox
              sx={{
                "& .MuiTableRow-root:not(:last-child)": {
                  "& td": {
                    borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                      `${borderWidth[1]} solid ${borderColor}`,
                  },
                },
              }}
            >
              {isLoading ? (
                <SoftBox
                  display="flex"
                  height="500px"
                  justifyContent="center"
                  alignItems="center"
                  p={3}
                >
                  <SoftTypography variant="subtitle1" color="textSecondary">
                    Loading...
                  </SoftTypography>
                </SoftBox>
              ) : configGroups.some((g) => g.rows?.length > 0) ? (
                <SoftBox px={2} pb={2}>
                  {configGroups
                    .filter((g) => g.rows?.length > 0)
                    .map((group) => (
                      <SoftBox key={group.group ?? "all"} mb={4}>
                        <SoftTypography
                          variant="h6"
                          fontWeight="bold"
                          color="dark"
                          mb={2}
                          mt={group.group != null && group.group !== "" ? 1 : 0}
                        >
                          {formatGroupHeading(group.group)}
                        </SoftTypography>
                        <Table columns={columns} rows={group.rows} />
                      </SoftBox>
                    ))}
                </SoftBox>
              ) : (
                <SoftBox display="flex" justifyContent="center" alignItems="center" p={3}>
                  <SoftTypography variant="subtitle1" color="textSecondary">
                    No Configs Data Found
                  </SoftTypography>
                </SoftBox>
              )}
            </SoftBox>
            {/* <SoftBox display="flex" alignItems="center" justifyContent="center" py={2}>
              <SoftButton
                variant="outlined"
                color="primary"
                onClick={() => handlePageClick(currentPage - 1)}
                disabled={currentPage === 1}
                sx={{ mx: 1 }}
              >
                Previous
              </SoftButton>

              <SoftButton
                key={currentPage}
                variant="contained"
                color="primary"
                // onClick={() => handlePageClick(pageNumber)}
                sx={{ mx: 0.5 }}
              >
                {currentPage}
              </SoftButton>

              <SoftButton
                variant="outlined"
                color="primary"
                onClick={() => handlePageClick(currentPage + 1)}
                disabled={currentPage === totalPages || totalPages === 0}
                sx={{ mx: 1 }}
              >
                Next
              </SoftButton>
            </SoftBox> */}
          </Card>
        </SoftBox>
      </SoftBox>
      )}
      <StreakGlobalSettingsDialog 
        open={isOpenGlobalSettingsDialog}
        onClose={handleClose}
        initialData={streakSettings}
        onSave={handleUpdateStreakGlobalSettings}
        loading={isUpdating}
      />
      <ConfirmDialog
        isOpen={isOpenDeleteDialog}
        handleClose={handleCloseDeleteDialog}
        handleConfirm={handleConfirmDelete}
        isLoading={isDeleting}
        title="Are you sure you want to delete this configuration?"
        actionText="Yes, Delete"
      />
      <Footer />
    </DashboardLayout>
  );
}
